export default "__VITE_ASSET__DEhAuvkN__"